<template>
  <div  class="vuse-content-wrapper content_category">
    <vuse-section-definition
      :title="page"
      :breadcrumbs="breadcrumbs"
      icon="mdi-package-variant"
    ></vuse-section-definition>
    <v-row class="mx-1 mt-4" >
      <v-col class="mx-3" cols="12">
        <v-select
          background-color="#EDF2F7"
          filled
          v-model="newPostConfigDetail.type"
          :items="type"
          item-text="text"
          item-value="id"
          label="Chọn loại"
        ></v-select>
      </v-col>
      <v-col class="mx-3" cols="12">
        <v-autocomplete
          background-color="#EDF2F7"
          filled
          v-model="newPostConfigDetail.category_slug"
          :items="categoryPost"
          item-text="name"
          item-value="slug"
          label="Nhập tên danh mục"
        ></v-autocomplete>
      </v-col>

      <v-col v-show="checkShow()" cols="12">
        <v-col>
          <h4 class="mt-1">Tin nổi bật</h4>
        </v-col>
        <v-col v-for="(item, key) in highlight_post_ids" :key="key">
          <v-autocomplete
            background-color="#EDF2F7"
            filled
            :items="news"
            v-model="item.post_id"
            item-text="name"
            item-value="id"
            label="Chọn bài viết 1"
          ></v-autocomplete>
        </v-col>
      </v-col>
      <v-col cols="6">
          <v-col cols="12" class="d-flex mt-3">
            <h4 class="mt-1">Tin hay</h4>
            <v-btn
              class="d-flex justify-end ml-3"
              color="primary"
              @click="addBlockCategory()" 
            >
              Thêm
            </v-btn>
          </v-col>
        <v-col><v-divider></v-divider></v-col>
        <v-col cols="12"
          v-for="(i, index) in category_post_ids"
          :key="index"
        >
          <v-row class="ma-0 pa-0">
            <v-col cols="10" class="ma-0 pa-0">
              <v-autocomplete
                v-model="i.category_post_id"
                label="Chọn danh mục"
                :items="categoryPost"
                item-text="name"
                item-value="id"
              ></v-autocomplete>
            </v-col>
            <v-col cols="2" class="ma-0 pa-0">
              <v-btn
                class="ma-2"
                outlined
              
                large
                color="indigo"
                @click="clearBlockCategory(i, index)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-col>
      <v-col cols="6">
          <v-col cols="12" class="d-flex mt-3">
            <h4 class="mt-1">Sản phẩm mới</h4>
            <v-btn
              class="d-flex justify-end ml-3"
              color="primary"
              @click="addBlockProduct()"
            >
              Thêm
            </v-btn>
          </v-col>
        <v-col><v-divider></v-divider></v-col>
        <v-col cols="12"
          v-for="(i, index) in product_ids"
          :key="index"
        >
          <v-row class="ma-0 pa-0">
            <v-col cols="10" class="ma-0 pa-0">
              <v-autocomplete
                v-model="i.product_id"
                label="Chọn sản phẩm"
                :items="productions"
                item-text="name"
                item-value="id"
              ></v-autocomplete>
            </v-col>
            <v-col cols="2" class="ma-0 pa-0">
              <v-btn
                class="ma-2"
                outlined
              
                large
                color="indigo"
                @click="clearBlockProduct(i, index)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-col>
      <v-col cols="6">
        <v-col cols="12" class="d-flex mt-3">
          <h4 class="mt-1">Thông tin - Khuyến mại</h4>
        </v-col>
        <v-col><v-divider></v-divider></v-col>
        <v-col cols="12">
          <v-row class="ma-0 pa-0">
            <v-col cols="12" class="ma-0 pa-0">
              <v-autocomplete
                v-model="post_sale_info"
                label="Chọn bài viết khuyến mại"
                :items="news"
                item-text="name"
                item-value="id"
                clearable
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-col>
      </v-col>
      <v-col cols="12" class="text-center">
        <v-btn color="primary" width="180" @click="update()"> Lưu </v-btn>
      </v-col>
    </v-row>

    <v-container fluid> </v-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { GET_LIST_CATEGORY_POST } from "@/store/modules/category_post";
import { GET_LIST_NEWS } from "@/store/modules/news";
import { GET_LIST_PRODUCT } from "@/store/modules/production";
import {
  GET_DETAIL_NEW_POST_CONFIG,
  UPDATE_DETAIL_NEW_POST_CONFIG,
} from "@/store/modules/confignew";

export default {
  data() {
    return {
      typeSelect: 0,
      headers: [
        { text: "STT", value: "id" },
        { text: "Tên", value: "name" },
        { text: "Actions", value: "actions" },
      ],

      page: "Sửa danh mục",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Quản lý trang",
          disabled: true,
        },
        {
          text: "Trang tin tức",
          disabled: true,
        },
        {
          text: "Sửa danh mục",
          disabled: true,
        },
      ],
      type: [
        {
          text: "Tin tức",
          id: "1",
        },
        {
          text: "Video",
          id: "2",
        },
      ],
      highlight_post_ids: [
        { post_id: null },
        { post_id: null },
        { post_id: null },
        { post_id: null },
        { post_id: null }
      ],
      product_ids: [],
      category_post_ids: [],
      post_sale_info: null,
      is_sale: 0
    };
  },
  watch: {
    newPostConfigDetail(val){
      this.product_ids = val.product_ids ?? [];
      this.is_sale = val.is_sale ?? 0;
      this.category_post_ids = val.category_post_ids ?? [];
      this.post_sale_info = val.post_sale_info ?? null;
      if(val.highlight_post_ids){
        val.highlight_post_ids.forEach((element, i) => {
          this.highlight_post_ids[i] = element;
        });
      }
    }
  },
  computed: {
    ...mapGetters({
      categoryPost: "categoryPost",
      news: "news",
      newPostConfigDetail: "newPostConfig",
      productions: "productions",
    }),
  },
  async created() {
    await this.$store.dispatch(`${GET_LIST_CATEGORY_POST}`);
    await this.$store.dispatch(`${GET_LIST_NEWS}`);
    await this.$store.dispatch(
      `${GET_DETAIL_NEW_POST_CONFIG}`,
      this.$route.params.id
    );
    await this.$store.dispatch(`${GET_LIST_PRODUCT}`);
  },
  methods: {
    update() {
      let form = {
        id: this.newPostConfigDetail.id,
        type: this.newPostConfigDetail.type,
        category_slug: this.newPostConfigDetail.category_slug,
        highlight_post_ids: JSON.stringify(this.highlight_post_ids),
        category_post_ids: JSON.stringify(this.category_post_ids),
        product_ids: JSON.stringify(this.product_ids),
        post_sale_info: this.post_sale_info,
        is_sale: this.is_sale
      };
      this.$store
        .dispatch(`${UPDATE_DETAIL_NEW_POST_CONFIG}`, form)
        .then((data) => {
          if (data.data.status == 1) {
            this.$toasted.success('Cập nhật thành công!', {
              duration:1000,
              position:'top-center'
            })
            this.$router.push("/manage_page/Page_manager");
          } else {
            alert(data.data.errors);
          }
        });
    },
    checkShow() {
      if (this.newPostConfigDetail.type === "2") {
        return false;
      } else {
        return true;
      }
    },
    addBlockCategory() {
      this.category_post_ids.push({
        category_post_id: null,   
      });
    },
    clearBlockCategory(i, index) {
      this.category_post_ids.splice(index, 1);
    },
    addBlockProduct() {
      this.product_ids.push({
        product_id: null
      });
    },
    clearBlockProduct(i, index) {
      this.product_ids.splice(index, 1);
    },
  },
};
</script>

<style lang="scss">
.content_category1 {
  background: #ffffff !important;
}
.content_category {
  background: #ffffff !important;
  .v-input__control {
    height: 65px !important;
  }
  .content-textarea .v-input__control {
    height: 165px !important;
  }
  .v-input--checkbox .v-input__control {
    height: 20px !important;
  }
}
.production .ck-editor__main .ck-content {
  height: 140px;
}
</style>